import {
    GROUP_TYPE,
    TerminalGroupConfiguration,
    GameGroupConfiguration
} from "../../reducers/editingConfiguration.reducer";
import GameInstance from "../../models/GameInstance.model";

/**
 * Returns an appropriate value-label array for the specified group type, and
 * given the provided Terminal Groups and Game Instances.
 * Will return an empty list if selected group type is neither GAME or
 * TERMINAL.
 * @param selectedGroupType { GROUP_TYPE } - The specified group type.
 * @param terminalGroups { TerminalGroupConfiguration[] } - Array of existing
 * TerminalGroupConfiguration objects.
 * @param gameGroups { GameGroupConfiguration[] } - Array of existing GameGroupConfiguration objects.
 * objects.
 * @returns Array<{value: string | number, label: string}>
 */
export default function groupListOfType(
    selectedGroupType: GROUP_TYPE,
    terminalGroups: TerminalGroupConfiguration[],
    gameGroups: GameGroupConfiguration[]
) {
    switch (selectedGroupType) {
        case GROUP_TYPE.TERMINAL:
            return terminalGroups.map(item => ({
                value: item.id,
                label: item.name
            }));
        case GROUP_TYPE.GAME:
            return gameGroups.map(item => ({
                value: item.id,
                label: item.name
            }));
        default:
            return [];
    }
}
